/*
 * Copyright (c) 2025.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/*
* wpaibase.ts
* 8-7-2024 - Jelmer Jellema - Spin in het Web B.V.
*
* Stripped basecomponent
* Dit is geen component, maar een helperclass. Dit betekent dat
* subclasses die wel een component of service zijn, een expliciete constructor moeten zetten...
*/


import {Directive} from "@angular/core";

@Directive()
export abstract class WPAIBase {
  //we bouwen de logcalls om console heen in de constructor:
  protected log: (...msg: any[]) => void;
  protected logwarn: (...msg: any[]) => void;
  private globalLogging: boolean = false; //als dit false is wordt er nooit gelogd

  protected constructor(private __logging: boolean = false) {
    if (this.globalLogging && __logging) {
      //bind console, zodat de regels kloppen
      this.log = (<any>console).log.bind(console);
      this.logwarn = (<any>console).warn.bind(console);
    } else {
      this.log = this.logwarn = () => {
      };
    }
  }
}
